/*!
 * ymm-core.js — browser glue: loads the JSON datasets and wires up window.YMMEngine into window.YMM.
 * Depends on ymm-engine.js (loaded first). Asset URLs come from window.YMM_ASSETS (injected by Liquid);
 * falls back to bare filenames so it also works when the theme dir is served statically for local QA.
 *   window.YMM.ready       → Promise<engine|null>  (tree + fitmap loaded; eager, small)
 *   window.YMM.loadVin()   → Promise<vinData>      (lazy; only when VIN is used)
 *   after ready, window.YMM proxies engine methods: verdict/fits/productSkus/fitTag/buildVehicle/…
 * Fires document 'ymm:ready' when the engine is live.
 */
(function (w) {
  'use strict';
  var A = w.YMM_ASSETS || {};
  var url = function (k, def) { return A[k] || def; };
  var mem = {};
  function loadJSON(u) {
    return fetch(u, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('YMM load failed: ' + u + ' (' + r.status + ')');
      return r.json();
    });
  }
  var YMM = w.YMM = w.YMM || {};
  YMM.assets = A;
  YMM.loadTree = function () { return mem.tree || (mem.tree = loadJSON(url('tree', 'ymm-tree.json'))); };
  YMM.loadFitmap = function () { return mem.fitmap || (mem.fitmap = loadJSON(url('fitmap', 'ymm-fitmap.json'))); };
  YMM.loadVin = function () { return mem.vin || (mem.vin = loadJSON(url('vin', 'ymm-vin.json'))); };

  // NOTE: every engine method the UI calls must be listed here — a missing name silently becomes
  // `undefined` on window.YMM and the caller renders nothing.
  var PROXY = ['productSkus', 'productCount', 'countProducts', 'fits', 'verdict', 'fitClass', 'fitTag', 'selFromVehicle', 'makes', 'makeName',
    'families', 'models', 'nodeOf', 'years', 'hasYear', 'yearsFor', 'findModel', 'buildVehicle',
    'yearBands', 'slug', 'platform', 'collectionHandle', 'fitUrl', 'vehicleFromHandle'];

  YMM.ready = Promise.all([YMM.loadTree(), YMM.loadFitmap()]).then(function (res) {
    if (!w.YMMEngine) throw new Error('ymm-engine.js not loaded');
    var engine = w.YMMEngine.create({ tree: res[0], fitmap: res[1] });
    YMM.engine = engine;
    PROXY.forEach(function (m) { YMM[m] = function () { return engine[m].apply(engine, arguments); }; });
    // Normalize a stored garage vehicle that predates canonical storage. ymm-leaf-garage-sync can persist a
    // RAW leaf object (display make "Harley-Davidson", no ffam/rmodel) when it fires before the engine is
    // ready — and verdict()/badges match row.make/row.family against veh.make/veh.ffam, so a raw object
    // silently fails ('nofit' on every ordinary collection). Rebuild it through the engine once, on ready,
    // and re-store+re-emit so cards re-badge. Guarded: no-op when already canonical (ffam present), and only
    // adopts the rebuild when it actually resolved (keeps bikes the tree can't build unchanged). (2026-07-28)
    try {
      var g = w.YMMGarage && w.YMMGarage.get && w.YMMGarage.get();
      if (g && g.ffam == null) {
        var built = engine.buildVehicle({ make: g.mk || g.make, family: g.vfam || g.family, model: g.rmodel || g.model, year: g.year });
        if (built && built.ffam != null) {
          if (!built.label) built.label = g.label;
          if (!built.fittag) built.fittag = g.fittag;
          w.YMMGarage.set(built);
        }
      }
    } catch (e) {}
    try { w.document.dispatchEvent(new CustomEvent('ymm:ready', { detail: engine })); } catch (e) {}
    return engine;
  }).catch(function (e) { if (w.console) console.warn('[YMM]', e.message || e); return null; });

  // convenience: run cb now if ready, else on 'ymm:ready'
  YMM.onReady = function (cb) { YMM.ready.then(function (eng) { if (eng) cb(eng); }); };

  // The bike THIS PAGE is about, from the URL — /collections/fits-2024-harley-davidson-street-glide.
  // A fitment landing page has its own bike, which is not necessarily the visitor's garage bike; the
  // page's copy is server-rendered for it, so the page must win over the garage when they disagree.
  // Returns null everywhere else (/collections/all, category collections, product pages).
  YMM.pageVehicle = function () {
    if (!YMM.engine) return null;
    var m = /\/collections\/([^/?#]+)/.exec(w.location.pathname);
    return m ? YMM.engine.vehicleFromHandle(m[1]) : null;
  };
})(window);
